import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { surveySchema } from "./schema";
import { fetchSurveyData } from "./read";
import { useMemo } from "react";
import { getRequiredFields } from "components/form/utils";
import { useUpdateCsat } from "../update/mutation";
import { useCreateSurvey } from "../create/mutation";
import { useNavigate } from "react-router-dom";
import { eventBus } from "utils/eventBus";

export const useCsatForm = ({ surveyId, jobId }) => {
  const navigate = useNavigate();
  const form = useForm({
    resolver: zodResolver(surveySchema),
    defaultValues: {
      title: "",
      questions: [],
    },
  });

  const requiredFields = useMemo(
    () => getRequiredFields(surveySchema),
    [surveySchema]
  );

  const updateCsat = useUpdateCsat();
  const createSurvey = useCreateSurvey();

  const handleCreate = async (context) => {

    const values = context.values;
    const response = await createSurvey.mutateAsync({
      item: {
        ...values,
        job: jobId,
      },
    });

  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    const response = await updateCsat.mutateAsync({
      surveyId: id,
      item: values,
    });
    eventBus.emit("refresh:list", `surveyssurveys-${jobId}`);
    navigate(`/work/jobs/${jobId}/surveys/${id}`);
  };

  const handleRead = async (id) => {
    const response = await fetchSurveyData({ surveyId: id });
    const data = {
      ...response,
    };
    return data;
  };

  return {
    form,
    requiredFields,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
